import { render } from "./KpiBoard.vue?vue&type=template&id=7106e12b&scoped=true"
import script from "./KpiBoard.vue?vue&type=script&lang=js"
export * from "./KpiBoard.vue?vue&type=script&lang=js"

import "./KpiBoard.vue?vue&type=style&index=0&id=7106e12b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7106e12b"]])

export default __exports__